.artwork {
  aspect-ratio: auto;
  height: clamp(10rem, 26vw, 18rem);
  border-radius: var(--radius-lg);
}
